import cx from "classnames";
import React from "react";
import Section from "../Section";

const About: React.FC = (): React.ReactElement => (
  <Section className="u-background-color-secondary" id="About">
    <div
      className={cx([
        "u-flex",
        "u-flex-column",
        "u-margin-top-negative-0point875rem",
        "u-margin-bottom-negative-0point875rem",
      ])}
    >
      <div
        className={cx([
          "u-flex",
          "u-justify-content-center",
          "u-padding-bottom-0point875rem",
          "u-padding-top-0point875rem",
          "u-width-fullWidth",
        ])}
      >
        <div
          className={cx([
            "u-padding-left-0point875rem",
            "u-padding-right-0point875rem",
            "u-width-59point65-percent",
          ])}
        >
          <p
            className={cx([
              "u-color-text",
              "u-font-size-m",
              "u-line-height-s",
              "u-margin-bottom-0",
              "u-margin-top-0",
              "u-text-normal",
              "u-text-center",
            ])}
          >
            <b>About Me</b>
            <br />
            <br />
          </p>
          <p
            className={cx([
              "u-color-text",
              "u-font-size-m",
              "u-line-height-s",
              "u-margin-bottom-0",
              "u-margin-top-0",
              "u-text-normal",
              // "u-text-center",
            ])}
            style={{ textAlign: "justify" }}
          >
            I&apos;m an L&D and Leadership Development professional with 7+
            years of experience building scalable learning ecosystems in both
            global financial services and social impact organizations. My work
            centers on developing leaders, elevating employee experience, and
            creating learning strategies that deliver measurable results.
            <br />
            <br />
            Most recently as a Learning Advisor at Scotiabank, I led a global
            People Manager Development program for 30 leaders, achieving a 93%
            confidence rating. Additionally, I directed a $1M onboarding program
            that produced 94% knowledge gains across 130 new Corporate and
            Investment Banking analysts. I&apos;ve also co-managed
            director-level development programs, led compliance training for
            1,500 employees, and chaired a U.S. Learning Council focused on
            strategy and metrics.
            <br />
            <br />
            Before financial services, I built the first centralized training
            function at Hamilton Families—launching their first LMS, designing
            leadership development programs, and contributing to the
            organization&apos;s initial Equity, Diversity, and Inclusion
            strategy.
            <br />
            <br />
            Across every role, I bring a blend of strategic thinking, program
            management, instructional design expertise, and a genuine passion
            for helping people grow.
          </p>
        </div>
      </div>
    </div>
  </Section>
);

export default React.memo(About);
